export default function imageUpload($sbImageApi, $q, $window, $sbFileReader) {
    "ngInject";

    const service = {
        uploadImages: uploadImages,
        transformAndUploadImage: transformAndUploadImage,
    };

    // image sizing and quality (when resizing) - in line with mobile app
    const MAX_ISSUE_ATTACHMENT_IMAGE_SIZE = 1600;
    const MAX_ISSUE_ATTACHMENT_IMAGE__THUMB_SIZE = 200;
    const IMAGE_QUALITY_WHEN_RESIZING = 0.95;

    return service;

    /**
     * Change the project image
     *
     * @param  {string} fileName      - the name of the image
     * @param  {Blob[]} blobPair      - the Image as data blob
     * @param  {string} projectId     - the project id where this image belongs to
     * @return {Promise}
     */
    function uploadImages(fileName, blobPair, projectId) {
        return $sbImageApi
            .upload(projectId, blobPair, {
                filename: fileName,
            })
            .then(function ({ id, url }) {
                return {
                    url: {
                        remote: url,
                    },
                    id,
                };
            });
    }

    /**
     * Take an image and resize it.
     * Return a resolved promise with the picture resized
     *
     * @param {object} image                                     - as handled by sbFileReader
     * @param {{maxSize: number, keepMetadata: boolean}} options - options with pixel based size of the new picture and if metadata is kept
     * @returns {Promise}
     */
    function _resizeImageAndAddOnArray(image, { maxSize, keepMetadata }) {
        return $sbFileReader.readAndResizeImage(
            image,
            maxSize,
            maxSize,
            keepMetadata,
            IMAGE_QUALITY_WHEN_RESIZING
        );
    }

    /**
     * Take a file transform it to thumb blob and full blob and upload it.
     *
     * @param {string} projectId
     * @param {File} file
     * @returns {Promise}
     * @private
     */
    function transformAndUploadImage(projectId, file) {
        return $q
            .all([
                _resizeImageAndAddOnArray(file, {
                    maxSize: MAX_ISSUE_ATTACHMENT_IMAGE_SIZE,
                    keepMetadata: true,
                }),
                _resizeImageAndAddOnArray(file, {
                    maxSize: MAX_ISSUE_ATTACHMENT_IMAGE__THUMB_SIZE,
                    keepMetadata: false, // not needed for thumb
                }),
            ])
            .then((images) => {
                const blobPair = images.map((image) => image.rawData);

                return uploadImages(undefined, blobPair, projectId);
            });
    }
}
